/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlaceType } from './PlaceType';
import {
    PlaceTypeFromJSON,
    PlaceTypeFromJSONTyped,
    PlaceTypeToJSON,
    PlaceTypeToJSONTyped,
} from './PlaceType';
import type { Airport1 } from './Airport1';
import {
    Airport1FromJSON,
    Airport1FromJSONTyped,
    Airport1ToJSON,
    Airport1ToJSONTyped,
} from './Airport1';
import type { City } from './City';
import {
    CityFromJSON,
    CityFromJSONTyped,
    CityToJSON,
    CityToJSONTyped,
} from './City';

/**
 * 
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * The airports associated to a city. This will only be provided where the `type` is `city`.
     * @type {Array<Airport1>}
     * @memberof Place
     */
    airports?: Array<Airport1> | null;
    /**
     * 
     * @type {City}
     * @memberof Place
     */
    city?: City;
    /**
     * The name of the city (or cities separated by a `/`) where the airport is located
     * @type {string}
     * @memberof Place
     */
    cityName: string | null;
    /**
     * The 3-letter IATA code for the city where the place is located. Only present for airports which are registered with IATA as belonging to a [metropolitan area](https://portal.iata.org/faq/articles/en_US/FAQ/How-do-I-create-a-new-Metropolitan-Area).
     * @type {string}
     * @memberof Place
     */
    iataCityCode: string | null;
    /**
     * The 3-letter IATA code for the place
     * @type {string}
     * @memberof Place
     */
    iataCode: string;
    /**
     * The [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code for the country where the city is located
     * @type {string}
     * @memberof Place
     */
    iataCountryCode: string;
    /**
     * The four-character ICAO code for the airport
     * @type {string}
     * @memberof Place
     */
    icaoCode: string | null;
    /**
     * Duffel's unique identifier for the resource
     * @type {string}
     * @memberof Place
     */
    id: string;
    /**
     * The latitude position of the airport represented in [Decimal degrees](https://en.wikipedia.org/wiki/Decimal_degrees) with 6 decimal points with a range between -90° and 90°
     * @type {number}
     * @memberof Place
     */
    latitude: number | null;
    /**
     * The longitude position of the airport represented in [Decimal degrees](https://en.wikipedia.org/wiki/Decimal_degrees) with 6 decimal points with a range between -180° and 180°
     * @type {number}
     * @memberof Place
     */
    longitude: number | null;
    /**
     * The name of the place
     * @type {string}
     * @memberof Place
     */
    name: string;
    /**
     * The time zone of the airport, specified by name from the [tz database](https://en.wikipedia.org/wiki/Tz_database)
     * @type {string}
     * @memberof Place
     */
    timeZone: string | null;
    /**
     * 
     * @type {PlaceType}
     * @memberof Place
     */
    type: PlaceType;
}



/**
 * Check if a given object implements the Place interface.
 */
export function instanceOfPlace(value: object): value is Place {
    if (!('cityName' in value) || value['cityName'] === undefined) return false;
    if (!('iataCityCode' in value) || value['iataCityCode'] === undefined) return false;
    if (!('iataCode' in value) || value['iataCode'] === undefined) return false;
    if (!('iataCountryCode' in value) || value['iataCountryCode'] === undefined) return false;
    if (!('icaoCode' in value) || value['icaoCode'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PlaceFromJSON(json: any): Place {
    return PlaceFromJSONTyped(json, false);
}

export function PlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Place {
    if (json == null) {
        return json;
    }
    return {
        
        'airports': json['airports'] == null ? undefined : ((json['airports'] as Array<any>).map(Airport1FromJSON)),
        'city': json['city'] == null ? undefined : CityFromJSON(json['city']),
        'cityName': json['city_name'],
        'iataCityCode': json['iata_city_code'],
        'iataCode': json['iata_code'],
        'iataCountryCode': json['iata_country_code'],
        'icaoCode': json['icao_code'],
        'id': json['id'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'name': json['name'],
        'timeZone': json['time_zone'],
        'type': PlaceTypeFromJSON(json['type']),
    };
}

export function PlaceToJSON(json: any): Place {
    return PlaceToJSONTyped(json, false);
}

export function PlaceToJSONTyped(value?: Place | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airports': value['airports'] == null ? undefined : ((value['airports'] as Array<any>).map(Airport1ToJSON)),
        'city': CityToJSON(value['city']),
        'city_name': value['cityName'],
        'iata_city_code': value['iataCityCode'],
        'iata_code': value['iataCode'],
        'iata_country_code': value['iataCountryCode'],
        'icao_code': value['icaoCode'],
        'id': value['id'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'name': value['name'],
        'time_zone': value['timeZone'],
        'type': PlaceTypeToJSON(value['type']),
    };
}

